'use client';

import {
  AIInput,
  AIInputSubmit,
  AIInputTextarea,
} from '@ahafood/ui/components/ai/input';
import type { FormEventHandler } from 'react';

interface ChatInputProps {
  text: string;
  onTextChange: (text: string) => void;
  onSubmit: FormEventHandler<HTMLFormElement>;
  isLoading?: boolean;
  status?: 'submitted' | 'streaming' | 'ready' | 'error';
}

export function ChatInput({
  text,
  onTextChange,
  onSubmit,
  isLoading = false,
  status = 'ready',
}: ChatInputProps) {
  return (
    <div className="px-4 pb-4 pt-2">
      <AIInput
        onSubmit={onSubmit}
        className="relative rounded-2xl border border-neutral-15 bg-white shadow-md transition-shadow focus-within:border-primary-30 focus-within:shadow-lg md:bg-white/60 md:backdrop-blur-md"
      >
        <AIInputTextarea
          className="pr-14 h-10 min-h-14 focus:min-h-20 transition-all duration-200 ease-in-out"
          placeholder="Ăn gì nào bạn ơi?"
          onChange={(e) => onTextChange(e.target.value)}
          value={text}
        />
        <AIInputSubmit
          className="absolute top-1/2 right-2.5 size-9 -translate-y-1/2 rounded-full bg-gradient-to-br from-primary-40 to-primary-50 text-white shadow-sm transition-all hover:opacity-90 hover:shadow-md disabled:from-neutral-20 disabled:to-neutral-20 disabled:text-neutral-40 disabled:shadow-none"
          disabled={
            !text ||
            isLoading ||
            status === 'streaming' ||
            status === 'submitted'
          }
          status={status}
        />
      </AIInput>
    </div>
  );
}
